import { z } from "zod";
export const transactionTypes = [
    "Buy",
    "Capital Gains Reinvestment",
    "Capital Gains",
    "Cash Deposit",
    "Cash Withdrawal",
    "Corporate Action",
    "Dividend Reinvestment",
    "Dividend",
    "Expense",
    "Income Reinvestment",
    "Income",
    "Interest Reinvestment",
    "Interest",
    "Journal",
    "Management Fee",
    "Option Activity",
    "Rebate",
    "Return of Capital",
    "Sale",
    "Short Sale",
    "Transfer In",
    "Transfer Out",
    "Valuation",
];
export const TransactionTypeEnum = z.enum(transactionTypes);
export const TransactionType = z.union([
    TransactionTypeEnum.transform((str) => ({
        type: str,
    })),
    z
        .string()
        .transform((str) => ({ type: "@Unknown", value: str })),
]);
export function getTransactionType(t) {
    if (t.type === "@Unknown") {
        return t.value;
    }
    return t.type;
}
//# sourceMappingURL=transactionType.js.map